<app-header></app-header>
<app-navbar></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100">
        <div class="row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat">{{ 'sidebar.discountControl' | translate }}
                </h2>
                <button type="button" class="btn custombutton" (click)="checkRow()">
                    {{ 'academicTaxes.newRegister' | translate }}
                </button>
            </div>
        </div>
        @if (this.discountTypeReponse.DiscountControlTypesDto.length &&
        this.discountTypeReponse.DiscountControlTypesDto.length > 0) {
        <div>
            <fieldset>
                <table class="table text-center mt-2" role="grid"
                    [attr.aria-label]="'sidebar.discountControl' | translate">
                    <thead>
                        <tr role="row">
                            <th scope="col"><span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{ 'discount.discountGeneral' | translate }}</th>
                            <th scope="col">{{ 'tariffRole.descripcion' | translate }}</th>
                            <th scope="col">{{ 'discount.controlValueType' | translate }}</th>
                            <th scope="col">{{ 'discount.alphanumeric' | translate }}</th>
                            <th scope="col">{{ 'discount.numericValue' | translate }}</th>
                            <th scope="col">{{ 'discount.decimalValue' | translate }}</th>
                            <th scope="col">{{ 'typesVat.date' | translate }}</th>
                            <th scope="col">{{ 'typesVat.endDate' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let discount of discountTypeReponse.DiscountControlTypesDto; let i = index"
                            [ngClass]="{'resaltado': selectedRowId === discount.idDiscountControlCheckValues}"
                            role="row">
                            <td role="gridcell">
                                <input [ariaLabel]="'flexRadioDefault' + discount.idDiscountControlCheckValues"
                                    type="radio" name="flexRadioDefault" [id]="'flexRadioDefault' + i"
                                    [checked]="selectedRowId === discount.idDiscountControlCheckValues"
                                    (click)="checkRow(discount)" />
                                <label [for]="'flexRadioDefault' + i" class="visually-hidden">
                                    {{ 'seleccionarFilaCon' | translate }}:
                                    {{ 'discount.discountGeneral' | translate }} {{
                                    discount.generalDiscountCatalogDto?.discountCode || 'N/A' }},
                                    {{ 'tariffRole.descripcion' | translate }} {{
                                    getNameDiscount(discount.generalDiscountCatalogDto?.generalDiscountCatalogTraductionDto)
                                    || 'N/A' }},
                                    {{ 'discount.controlValueType' | translate }} {{
                                    discount.discountControlTypeDto?.description || 'N/A' }},
                                    {{ 'discount.alphanumeric' | translate }} {{ discount.alphanumericValue || 'N/A' }},
                                    {{ 'discount.numericValue' | translate }} {{ discount.numericValue || 'N/A' }},
                                    {{ 'discount.decimalValue' | translate }} {{ discount.decimalValue || 'N/A' }},
                                    {{ 'typesVat.date' | translate }} {{ discount.dateStart | date:'dd/MM/yyyy'
                                    }},
                                    {{ 'typesVat.endDate' | translate }} {{ discount.dateEnd | date:'dd/MM/yyyy' }}
                                </label>
                            </td>
                            <td role="gridcell"><span>{{ discount.generalDiscountCatalogDto?.discountCode }}</span></td>
                            <td role="gridcell"><span>{{
                                    getNameDiscount(discount.generalDiscountCatalogDto?.generalDiscountCatalogTraductionDto)
                                    }}</span></td>
                            <td role="gridcell"><span>{{ discount.discountControlTypeDto?.description }}</span></td>
                            <td role="gridcell"><span>{{ discount.alphanumericValue }}</span></td>
                            <td role="gridcell"><span>{{ discount.numericValue }}</span></td>
                            <td role="gridcell"><span>{{ discount.decimalValue }}</span></td>
                            <td role="gridcell"><span>{{ discount.dateStart | date:'dd/MM/yyyy' }}</span></td>
                            <td role="gridcell"><span>{{ discount.dateEnd | date:'dd/MM/yyyy' }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>

            <div class="mt-2" *ngIf="this.discountTypeReponse.pageDto">
                <app-paginator [isStart]="this.discountTypeReponse.pageDto.start"
                    [isEnd]="this.discountTypeReponse.pageDto.end"
                    [currentPage]="this.discountTypeReponse.pageDto.currentPage"
                    [totalPages]="this.discountTypeReponse.pageDto.pages"
                    [numberRecord]="this.discountTypeReponse.pageDto.records"
                    [sizePage]="this.discountTypeReponse.pageDto.pageSize">
                </app-paginator>
            </div>
        </div>
        }
        @if (this.selectedRowId || isCreate) {
        <div class="separator mt-5"></div>

        <div>
            <form [formGroup]="discountTypeForm" (ngSubmit)="createOrUpdateDiscount()">
                <div class="mt-5">
                    @if(!this.selectedRowId){
                    <h2 class="textformat mb-4 color-text">{{ 'discount.create' |
                        translate }}</h2>
                    }@else {
                    <h2 class="textformat mb-4 color-text">{{ 'discount.editat' |
                        translate }}</h2>
                    }
                </div>

                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label for="service">{{'discount.controlValueType' |translate}}<span>
                                *</span></label>
                        <select id="service" class="form-select mt-2" aria-label="activity"
                            formControlName="idDiscountControlType" name="service">
                            <option *ngFor="let type of this.listDiscountControlType"
                                [value]="type.idDiscountControlType">
                                {{ type.description }}
                            </option>
                        </select>
                    </div>

                    <!-- Listado descuentos -->
                    <div class="col-md-6 mb-3">
                        <label for="idGeneralDiscountCatalog">{{'discount.discountGeneral' |translate}}<span>
                                *</span></label>
                        <select id="idGeneralDiscountCatalog" name="idGeneralDiscountCatalog" class="form-select mt-2"
                            aria-label="activity" formControlName="idGeneralDiscountCatalog">
                            <option value=""></option>
                            <option *ngFor="let type of this.listGeneralDiscountCatalogDto"
                                [value]="type.idGeneralDiscountCatalog">
                                {{ type.discountCode }} - <span
                                    *ngIf="type.generalDiscountCatalogTraductionDto && type.generalDiscountCatalogTraductionDto.length>0">
                                    {{type.generalDiscountCatalogTraductionDto[0].discountDescription || ''}}</span>
                            </option>
                        </select>
                    </div>

                    <!-- Service id -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="alphanumericValue">{{ 'discount.alphanumeric' | translate
                            }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="alphanumericValue"
                            name="alphanumericValue" required formControlName="alphanumericValue">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="decimalValue">{{ 'discount.decimalValue' | translate }}<span>
                                *</span></label>
                        <input type="number" class="form-control color-text" id="decimalValue" name="decimalValue"
                            required formControlName="decimalValue">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="numericValue">{{ 'discount.numericValue' | translate }}<span>
                                *</span></label>
                        <input type="number" class="form-control color-text" id="numericValue" name="numericValue"
                            required formControlName="numericValue">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="dateStart">{{ 'typesVat.date' | translate }}<span>
                                *</span></label>
                        <input type="date" class="form-control color-text" id="dateStart" name="dateStart" required
                            formControlName="dateStart">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="dateEnd">{{ 'typesVat.endDate' | translate }}<span>
                                *</span></label>
                        <input type="date" class="form-control color-text" id="dateEnd" name="dateEnd" required
                            formControlName="dateEnd">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="intervalValueStart">{{ 'typesVat.intervalStart' | translate }}<span>
                                </span></label>
                        <input type="number" class="form-control color-text" id="intervalValueStart" name="intervalValueStart" 
                            formControlName="intervalValueStart">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="intervalValueEnd">{{ 'typesVat.intervalEnd' | translate }}<span>
                                *</span></label>
                        <input type="number" class="form-control color-text" id="intervalValueEnd" name="intervalValueEnd" required
                            formControlName="intervalValueEnd">
                    </div>
                </div>
                <button type="button" class="btn cancelbutton mt-3" (click)="selectedRowId = null; isCreate = false ">
                    {{ 'administrativeTaxes.cancel' | translate }}
                </button>
                @if(!this.selectedRowId){
                <button type="submit" class="btn custombutton mt-3 mx-2">{{ 'buttons.save' | translate
                    }}</button>
                }@else {
                <button type="submit" class="btn custombutton mt-3 mx-2">{{ 'buttons.modify' | translate
                    }}</button>
                }

            </form>
        </div>
        }
        <app-alert-component [isOk]="messageVisibility.isSuccessFirst" [isDanger]="messageVisibility.isErrorFirts"
            [message]="errorMessage"
            (close)="messageVisibility.isSuccessFirst = messageVisibility.isErrorFirts = false"></app-alert-component>
    </main>
</div>